export default "__VITE_ASSET__D79tDrz6__"